<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        <div class="header-row flex flex-align-center gap-lg">
          @if (checkPoint()) {
            <app-checkpoint-form-header
              class="mr-auto"
              [checkpointName]="checkPoint()!.name"
              [formName]="$safeNavigationMigration(form()?.name)"
            />
          } @else {
            <span class="mr-auto">{{ title() }}</span>
          }
        </div>
      </app-card-title>
    </app-card-header>

    <app-card-content>
      @if (loading()) {
        <div
          class="loading-container flex flex-column flex-align-center flex-justify-center gap-md"
        >
          <app-spinner></app-spinner>
          <p>{{ 'qrCode.loading' | translate }}</p>
        </div>
      } @else if (error()) {
        <div class="error-message">
          <p>{{ error() }}</p>
        </div>
      } @else {
        <div class="qr-content flex flex-column flex-align-center gap-2xl">
          @if (description()) {
            <div class="qr-label flex flex-column gap-sm">
              <span class="text-center">{{
                'qrCode.label.scanOtherDevice' | translate: { formName: form()?.name ?? '' }
              }}</span>
              <span class="or-line text-md font-bold text-center" data-testid="qr-or-line">{{
                'qrCode.label.or' | translate
              }}</span>
              <div
                class="qr-label text-md"
                data-testid="qr-label"
                internalLinkRouting
                [innerHTML]="
                  'qrCode.label.clickThisDevice' | translateMarkdown: { link: routerUrl() }
                "
              ></div>
            </div>
          }

          <div class="qr-code-container flex flex-justify-center m-lg">
            <a [routerLink]="routerUrl()" [tippy]="linkText()">
              <qrcode
                [qrdata]="qrUrl()"
                [width]="256"
                [errorCorrectionLevel]="'M'"
                [margin]="1"
              ></qrcode>
            </a>
          </div>

          <div class="actions flex gap-md flex-wrap flex-justify-center">
            @if (form()) {
              <app-button
                variant="outlined"
                (click)="editForm()"
                data-testid="edit-form-btn"
                *hasPermission="'form.update'"
              >
                <app-icon name="pencil" />
                {{ 'component.qr.editForm' | translate }}
              </app-button>
              <app-button variant="outlined" (click)="viewHistory()">
                <app-icon name="history" />
                {{ 'component.qr.history' | translate }}
              </app-button>
            }
            <app-button variant="outlined" (click)="downloadQrCode()">
              <app-icon name="download" />
              {{ 'component.qr.download' | translate }}
            </app-button>
            <app-button variant="outlined" (click)="printQrCode()">
              <app-icon name="printer" />
              {{ 'component.qr.print' | translate }}
            </app-button>
            <app-button
              variant="outlined"
              (click)="printLabels()"
              *hasPermission="'label.print'"
              data-testid="print-labels-btn"
            >
              <app-icon name="tag" />
              {{ 'component.qr.printLabels' | translate }}
            </app-button>
          </div>
        </div>
      }
    </app-card-content>
  </app-card>
</div>
